import src from "IMAGE";
export default { src, width: 108, height: 69, blurWidth: 0, blurHeight: 0};
